import enquire from 'enquire.js';
import store from '../store/index';

const root = document.documentElement;
let prevLayout = {};
let backupVars = {};

const layouts = {
  '(max-width: 480px)': {
    projectsColumn: true,
    twoRowHeader: true,
    vars: {
      'promo-name-font': '72px',
    },
  },
  '(min-width: 481px) and (max-width: 660px)': {
    projectsColumn: true,
    vars: {
      'promo-name-font': '72px',
    },
  },
  '(min-width: 661px) and (max-width: 1024px)': {
  },
  '(min-width: 1025px) and (max-width: 1280px)': {
    twoColumnProjects: true,
  },
  '(min-width: 1281px)': {
    twoColumnTeam: true,
    twoColumnProjects: true,
  },
};

function handleMedia(layoutKey) {
  const layoutData = layouts[layoutKey];
  store.commit('setLayout', layoutData);

  if (prevLayout.vars) {
    Object.entries(backupVars).forEach(([key, value]) => {
      root.style.setProperty(`--${key}`, value);
    });
  }

  backupVars = {};

  if (layoutData.vars) {
    const rootStyle = getComputedStyle(root);

    Object.entries(layoutData.vars).forEach(([key, value]) => {
      backupVars[key] = rootStyle.getPropertyValue(`--${key}`);
      root.style.setProperty(`--${key}`, value);
    });
  }

  prevLayout = layoutData;
}

export function registerQueries() {
  Object.keys(layouts).forEach((query) => {
    const listener = () => handleMedia(query);

    enquire.register(`screen and ${query}`, listener);
  });
}
